var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9998 6.00732V3.00732C6.9998 2.45504 7.44752 2.00732 7.9998 2.00732H19.9998C20.5521 2.00732 20.9998 2.45504 20.9998 3.00732V17.0073C20.9998 17.5596 20.5521 18.0073 19.9998 18.0073H16.9998V21.0064C16.9998 21.5592 16.5499 22.0073 15.993 22.0073H4.00666C3.45059 22.0073 3 21.5627 3 21.0064L3.0026 7.00819C3.0027 6.45543 3.45264 6.00732 4.00942 6.00732H6.9998ZM5.00242 8.00732L5.00019 20.0073H14.9998V8.00732H5.00242ZM8.9998 6.00732H16.9998V16.0073H18.9998V4.00732H8.9998V6.00732Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.76274cc3f2036ba6cd935be2113e3343.svg";
export { ForwardRef as ReactComponent };